<template>
    <div class="container uslugi">
        <template v-for="(item, index) in uslugi.list" :key="index">
            <div class="uslugi-card-wrap">
                <UslugiCard :item="item" @return-komu="handleEventReturnKomu"></UslugiCard>
            </div>
        </template>
    </div>
    <PopupBlock v-if="popup" @event-close-popup="this.popup = false"><ConsultForm :sendResult="sendResult" :komu="komu" @return-data="handleEventReturnData"></ConsultForm></PopupBlock>
</template>
<script>
import uslugi from '@/lib/uslugi'
import UslugiCard from './UslugiCard.vue'
import PopupBlock from './PopupBlock.vue'
import ConsultForm from './ConsultForm.vue'

export default {
    name: 'UslugiBlock',
    components: {
        UslugiCard,
        PopupBlock,
        ConsultForm,
    },
    emits: [ 'returnData' ],
    props: {
        sendResult: Object
    },
    data() {
        return {
            uslugi,
            komu: '',
            popup: false,
        }
    },
    mounted() {
    },
    methods: {
        handleEventReturnKomu: function(komu) {
            this.komu = komu
            this.popup = true
        },
        handleEventReturnData: function(data) {
            this.$emit('returnData', { ...data } )
        },
    }
}
</script>
<style lang="scss">
.uslugi{
    margin-top: 20px;
    .uslugi-card-wrap{
        margin-bottom: 20px;
    }
}
</style>